var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { staticClass: "asta-nav", attrs: { app: "", dark: "" } },
    [
      _c(
        "v-app-bar-nav-icon",
        { on: { click: _vm.toggleDrawer } },
        [
          _c(
            "v-btn",
            { attrs: { fab: "", small: "", depressed: "", text: "" } },
            [_c("v-icon", [_vm._v("menu")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column align-self-start align-center",
          style: { marginTop: !_vm.is_mobile ? "5px" : "0px" },
        },
        [
          _c(
            "div",
            { staticClass: "text-center mb-1" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "gradient-green",
                  attrs: { rounded: "", small: "", text: "" },
                  on: { click: _vm.promptImpostazioni },
                },
                [
                  _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                    _vm._v("settings"),
                  ]),
                  _vm._v(
                    "\n        " + _vm._s(_vm.asta_mode_name) + "\n        "
                  ),
                  _c("v-icon", { attrs: { small: "", right: "" } }, [
                    _vm._v("expand_more"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-center align-center" },
            [
              !_vm.Config.STANDALONE
                ? _c(
                    "v-btn",
                    {
                      staticClass: "navy darken-2 white--text mr-1 con-ombra",
                      attrs: { fab: "", "x-small": "", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.checkAllineamentoRose(true)
                        },
                      },
                    },
                    [_c("v-icon", { attrs: { small: "" } }, [_vm._v("sync")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("semaforo", { attrs: { mode: "bar" } }),
              _vm._v(" "),
              !_vm.Config.STANDALONE
                ? _c(
                    "v-btn",
                    {
                      staticClass: "navy darken-2 white--text ml-1 con-ombra",
                      attrs: { fab: "", "x-small": "", depressed: "" },
                      on: { click: _vm.promptSaveRose },
                    },
                    [_c("v-icon", [_vm._v("save")])],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "v-speed-dial",
        {
          staticClass: "speeddial",
          attrs: { direction: "bottom" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function () {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        fab: "",
                        "x-small": "",
                        text: "",
                        depressed: "",
                      },
                    },
                    [
                      _vm.fab_aspect
                        ? _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("close"),
                          ])
                        : _c(
                            "div",
                            [
                              _vm.useSound
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-n1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v(" volume_up ")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-n1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v(" volume_off ")]
                                  ),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                { staticClass: "ml-n1", attrs: { small: "" } },
                                [_vm._v(" more_vert ")]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.fab_aspect,
            callback: function ($$v) {
              _vm.fab_aspect = $$v
            },
            expression: "fab_aspect",
          },
        },
        [
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
              model: {
                value: _vm.soundModel,
                callback: function ($$v) {
                  _vm.soundModel = $$v
                },
                expression: "soundModel",
              },
            },
            [
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: 0 },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { class: _vm.colorSpeedDial, attrs: { small: "" } },
                    [_vm._v("volume_off")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: 1 },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { class: _vm.colorSpeedDial, attrs: { small: "" } },
                    [_vm._v("volume_up")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
              model: {
                value: _vm.tavoloLayoutModel,
                callback: function ($$v) {
                  _vm.tavoloLayoutModel = $$v
                },
                expression: "tavoloLayoutModel",
              },
            },
            [
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.TAVOLO_LAYOUT.CERCHIO },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { class: _vm.colorSpeedDial, attrs: { small: "" } },
                    [_vm._v("lens")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.TAVOLO_LAYOUT.GRIGLIA },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("v-icon", { class: _vm.colorSpeedDial }, [
                    _vm._v("view_module"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.tavoloLayoutModel ==
                    _vm.Constants.TAVOLO_LAYOUT.CERCHIO,
                  expression:
                    "tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO",
                },
              ],
              staticClass: "icone-cerchi",
              attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
              model: {
                value: _vm.tavoloSizeModel,
                callback: function ($$v) {
                  _vm.tavoloSizeModel = $$v
                },
                expression: "tavoloSizeModel",
              },
            },
            [
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.TAVOLO_SIZE.SMALL },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.TAVOLO_SIZE.MEDIUM },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.TAVOLO_SIZE.LARGE },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_c("v-icon", { class: _vm.colorSpeedDial }, [_vm._v("lens")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn-toggle",
            {
              staticClass: "icone-cerchi",
              attrs: { dense: "", rounded: "", borderless: "", mandatory: "" },
              model: {
                value: _vm.squadreSizeModel,
                callback: function ($$v) {
                  _vm.squadreSizeModel = $$v
                },
                expression: "squadreSizeModel",
              },
            },
            [
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.SQUADRE_SIZE.SMALL },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("v-icon", { class: _vm.colorSpeedDial }, [
                    _vm._v("account_box"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.SQUADRE_SIZE.MEDIUM },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("v-icon", { class: _vm.colorSpeedDial }, [
                    _vm._v("account_box"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.bgSpeedDial,
                  attrs: { value: _vm.Constants.SQUADRE_SIZE.LARGE },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("v-icon", { class: _vm.colorSpeedDial }, [
                    _vm._v("account_box"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }